import { useState } from 'react';
import { Tabs, Select } from 'antd';
import { PageHeader } from '../../components/common/PageHeader';
import { RevenueChart } from '../../components/charts/RevenueChart';
import { UserGrowthChart } from '../../components/charts/UserGrowthChart';
import { ProcessingChart } from '../../components/charts/ProcessingChart';
import { useRevenueMetrics, useUserMetrics, useProcessingMetrics } from '../../hooks/useAnalytics';

export function AnalyticsPage() {
  const [days, setDays] = useState(30);
  const { data: revenue, isLoading: revLoading } = useRevenueMetrics(days);
  const { data: users, isLoading: usersLoading } = useUserMetrics(days);
  const { data: processing, isLoading: procLoading } = useProcessingMetrics(days);

  return (
    <>
      <PageHeader title="Analytics" extra={
        <Select value={days} onChange={setDays} style={{ width: 120 }} options={[{ label: '7 days', value: 7 }, { label: '30 days', value: 30 }, { label: '90 days', value: 90 }, { label: '365 days', value: 365 }]} />
      } />
      <Tabs items={[
        { key: 'revenue', label: 'Revenue', children: <RevenueChart data={revenue?.map((r) => ({ date: r.period, mrr_usd: r.mrr_usd, arr_usd: r.arr_usd })) || []} loading={revLoading} /> },
        { key: 'users', label: 'Users', children: <UserGrowthChart data={users?.map((u) => ({ date: u.period, new_signups: u.new_signups, churned_users: u.churned_users })) || []} loading={usersLoading} /> },
        { key: 'processing', label: 'Processing', children: <ProcessingChart data={processing || []} loading={procLoading} /> },
      ]} />
    </>
  );
}
